import {GeneralAction} from '../../../@types/actions';
import {GET_ACTIVE_PLAYERS} from '../../../constants/PlayerConstants';

export const GetActivePlayersAction = (): GeneralAction<undefined> => ({
    type: GET_ACTIVE_PLAYERS,
    payload: undefined,
});
